import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Navegacao em SPA nao mexe no scroll: quem clica no link do diagnostico la
 * embaixo da landing chega na pagina nova ja no meio dela, sem titulo nem
 * contexto. Isto devolve o comportamento que o navegador tem em site normal.
 */
export function RolarParaOTopo() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    aplicarRolagemDaRota(hash, (id) => document.getElementById(id),
      () => window.scrollTo({ top: 0 }));
  }, [pathname, hash]);
  return null;
}

export function aplicarRolagemDaRota(
  hash: string,
  localizar: (id: string) => { scrollIntoView: () => void } | null,
  rolarTopo: () => void,
): void {
  const fragmento = hash.startsWith("#") ? hash.slice(1) : "";
  let id = fragmento;
  try { id = decodeURIComponent(fragmento); } catch { /* fragmento inválido não bloqueia a navegação */ }
  const alvo = id ? localizar(id) : null;
  if (alvo) alvo.scrollIntoView();
  else rolarTopo();
}
